import React, { Component } from 'react';
import { Button } from 'semantic-ui-react';

import RejectMealModal from './Modal/RejectMealModal';

class MealApproveButtons extends Component {
  render() {
    const {
        list,
        approveAllMeal,
        approveSelectedMeal,
        checkedCount,

        modal,
        openModal,
        closeModal,
        members,
        rejectMeal
      } = this.props.btnFn,
      modalFn = {
        open: modal,
        closeModal: closeModal,
        count: checkedCount,
        members: members,
        rejectMeal: rejectMeal
      };

    let totalCount = list ? list.data.totalcount : 0;

    return (
      <div className="approve-btns">
        <span className="member-count">
          {checkedCount} / {totalCount}명
        </span>

        <Button color="green" onClick={approveAllMeal}>
          모두 승인
        </Button>
        <Button inverted color="green" onClick={approveSelectedMeal}>
          선택 승인
        </Button>
        <Button inverted color="red" onClick={openModal}>
          반려
        </Button>

        <RejectMealModal modalFn={modalFn} />
      </div>
    );
  }
}

export default MealApproveButtons;
